import { analyticsPage } from "./analyticsPolicy";

let frame = null;
let ready = false;
let page = null;
const postPage = () => {
  if (ready && frame && page) frame.contentWindow.postMessage({ type: "analytics-page", page }, "*");
};
const onReady = event => {
  if (event.source !== frame?.contentWindow || event.origin !== "null" || event.data?.type !== "analytics-ready") return;
  ready = true;
  postPage();
};

export function stopAnalytics() {
  window.removeEventListener("message", onReady);
  frame?.remove();
  frame = null; ready = false; page = null;
}

export function setAnalyticsPage(consent, pathname) {
  const next = analyticsPage(pathname);
  if (consent !== "accepted" || !next) { stopAnalytics(); return; }
  const changed = page !== next;
  page = next;
  if (!frame) {
    frame = document.createElement("iframe");
    frame.hidden = true;
    frame.title = "Optional usage analytics";
    frame.setAttribute("sandbox", "allow-scripts");
    frame.setAttribute("referrerpolicy", "no-referrer");
    frame.src = "/analytics.html";
    window.addEventListener("message", onReady);
    document.body.append(frame);
  } else if (changed) postPage();
}

export function trackPracticeNote() {
  if (ready && frame && page === "/training") frame.contentWindow.postMessage({ type: "analytics-event", event: "ear_trainer_note" }, "*");
}
